import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { AppFlyoutFlexContainerWidth, FlyoutDividerHeight, FlyoutFlexContainerWidth, FlyoutFooterDividerWidth, FlyoutFooterHeight, FlyoutFooterMinHeight, FlyoutResultsDividerWidth, FlyoutTileContainerHeight, FlyoutTileContainerLeftPadding, FlyoutTileContainerMaxHeightWithSearch, FlyoutTileContainerTopMargin, FlyoutTileContainerWidth, } from './Constants';
/**
 * Styles used for the internal rendered content of the more apps Flyout
 */
export var useFlyoutStyles = makeStyles({
    root: {
        maxHeight: 'inherit',
        minHeight: 'inherit',
        maxWidth: AppFlyoutFlexContainerWidth,
    },
    tilesContainer: __assign(__assign({ maxHeight: FlyoutTileContainerHeight, minHeight: '250px', width: '100%', marginBottom: 'auto' }, shorthands.overflow('auto')), { '@media (max-width: 320px)': {
            minHeight: '150px',
        } }),
    tilesContainerSearchEnabled: {
        maxHeight: FlyoutTileContainerMaxHeightWithSearch,
    },
    installedAppsWrapper: __assign(__assign({ width: FlyoutTileContainerWidth }, shorthands.margin(FlyoutTileContainerTopMargin, '0', '0', 'auto')), shorthands.padding('0', '0', '0', FlyoutTileContainerLeftPadding)),
    suggestedAppsWrapper: __assign({ width: FlyoutTileContainerWidth }, shorthands.gap('4px')),
    tilesEmptyStateContainer: __assign(__assign(__assign({ minHeight: '250px', width: FlyoutTileContainerWidth }, shorthands.margin('0', '0', 'auto', '0')), shorthands.overflow('auto')), { justifyContent: 'center', '@media (max-width: 320px)': {
            minHeight: '150px',
        } }),
    tilesEmptyStateMessage: __assign({ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', textAlign: 'center' }, shorthands.gap('8px')),
    dividerCommon: {
        maxHeight: FlyoutDividerHeight,
        width: FlyoutFooterDividerWidth,
    },
    resultsDivider: __assign({ width: FlyoutResultsDividerWidth }, shorthands.margin('5px', 'auto')),
    footerContainer: __assign(__assign({ width: FlyoutFlexContainerWidth }, shorthands.margin(0, 'auto')), { lineHeight: tokens.lineHeightHero800, fontSize: tokens.fontSizeBase100, height: FlyoutFooterHeight, minHeight: FlyoutFooterMinHeight, alignSelf: 'stretch', justifyContent: 'space-between', flexDirection: 'row-reverse', '@media (max-width: 320px)': __assign(__assign({}, shorthands.margin(0, 0, 0, 'auto')), { minHeight: '64px' }) }),
    searchBoxRoot: __assign({ width: '90%', height: '32px' }, shorthands.margin('16px', 'auto', '0', 'auto')),
    searchBoxInput: {
        width: '100%',
        ':focus-within': {
            ':after': {
                borderBottomColor: tokens.colorNeutralForeground3BrandSelected,
            },
        },
    },
    searchBoxIcon: __assign(__assign({}, shorthands.margin('3px', '0', '0', '0')), { color: tokens.colorNeutralForeground1 }),
    noResultsTitle: {
        width: '100%',
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightBold,
    },
    noResultsMessage: {
        width: '100%',
    },
    listItem: {
        listStyleType: 'none',
    },
    searchResultsStatusMessage: __assign(__assign(__assign(__assign({ clip: 'rect(0px, 0px, 0px, 0px)', height: '1px' }, shorthands.margin('-1px')), shorthands.overflow('hidden')), shorthands.padding('0px')), { width: '1px', position: 'absolute' }),
});
//# sourceMappingURL=Flyout.styles.js.map